import React from 'react';
import styled from 'styled-components';

import MaterialSwitchButton from '../../../common/MaterialSwitchButton';

const Container = styled.div`
    height: 56px;
    margin-left: 56px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    ${props => !props.noborder && 'border-top: 1px solid #ebedf0;'}
`;

// To Do: use Material UI Typography with theme
const StyledLabel = styled.p`
    color: black;
    font-size: 17px;
    font-family: Cabin;
    line-height: 24px;
`;

const FeatureItem = ({ name, onChange, label, checked, noBorderTop }) => {
    return (
        <Container noborder={noBorderTop ? 1 : 0}>
            <StyledLabel>{label}</StyledLabel>
            <MaterialSwitchButton name={name} onChange={onChange} label="" checked={checked} />
        </Container>
    );
};

export default FeatureItem;
